import {
  shiftRight2gqph14wydb8s as shiftRight,
  convertToInty04h231mmjoh as convertToInt,
  negate13xrbakfwasjy as negate,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
  toNumber2e2hj9zugjwi2 as toNumber,
  shiftLeft3tsh2sstjchzn as shiftLeft,
  numberToLong2pakxeg38estk as numberToLong,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb as DurationUnit_NANOSECONDS_getInstance,
  convertDurationUnit2jq3wf7d49p64 as convertDurationUnit,
  convertDurationUnit1gi5cqpfj6qf3 as convertDurationUnit_0,
  DurationUnit_DAYS_getInstance3he068lsy3pdd as DurationUnit_DAYS_getInstance,
  DurationUnit_HOURS_getInstance2sdyct9eiytro as DurationUnit_HOURS_getInstance,
  DurationUnit_MINUTES_getInstance33ilufdckt9os as DurationUnit_MINUTES_getInstance,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  convertDurationUnitOverflow13zjt78f02ii6 as convertDurationUnitOverflow,
} from './DurationUnitJs.mjs';
import {
  AssertionError3yq7q0knw9m5 as AssertionError,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../js/coreRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import {
  coerceIn302bduskdb54x as coerceIn,
  coerceAtLeast3qxv4gros2xti as coerceAtLeast,
} from '../ranges/_Ranges.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../text/StringBuilderJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__minus_impl_a2frrhw2puetaduxyd as Char__minus_impl_a2frrh,
  toString1n9qg6fb0b5i8 as toString_0,
} from '../Char.mjs';
import {
  padStart36w1507hs626a as padStart,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
} from '../text/Strings.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../js/charSequenceJs.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../Comparable.mjs';
import {
  get_signed9wrgmju9wx as get_sign,
  abs22kdeprm0tm5i as abs,
  roundToLong2s902lrwaad4n as roundToLong,
} from '../math/math.mjs';
import { convertDurationUnitToMilliseconds1tijfu5c343f5 as convertDurationUnitToMilliseconds } from './DurationUnit.mjs';
import { isNaNymqb93xtq8w8 as isNaN_0 } from '../NumbersJs.mjs';
import { regionMatches30ph926sbb53j as regionMatches } from '../text/stringsCode.mjs';
import { substringiqarkczpya5m as substring } from '../text/stringJs.mjs';
import { toDouble1kn912gjoizjp as toDouble } from '../text/numberConversions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _Duration___init__impl__kdtzql(rawValue) {
  return rawValue;
}
function _get_rawValue__5zfu4e($this) {
  return $this;
}
function _get_value__a43j40($this) {
  return shiftRight(_get_rawValue__5zfu4e($this), 1);
}
function isInNanos($this) {
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  return (convertToInt(_get_rawValue__5zfu4e($this)) & 1) === 0;
}
function isInMillis($this) {
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  return (convertToInt(_get_rawValue__5zfu4e($this)) & 1) === 1;
}
function _get_storageUnit__szjgha($this) {
  return isInNanos($this) ? DurationUnit_NANOSECONDS_getInstance() : DurationUnit_MILLISECONDS_getInstance();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ki_1 = _Duration___init__impl__kdtzql(0n);
        this.li_1 = durationOfMillis(4611686018427387903n);
        this.mi_1 = durationOfMillis(-4611686018427387903n);
        this.ni_1 = 9223372036854759646n;
        this.oi_1 = _Duration___init__impl__kdtzql(9223372036854759646n);
      }
      ds(rawValue) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Duration())(_Duration___init__impl__kdtzql(rawValue));
        var $this$apply = this_0.ji_1;
        // Inline function 'kotlin.time.durationAssertionsEnabled' call
        if (true) {
          if (isInNanos($this$apply)) {
            var containsArg = _get_value__a43j40($this$apply);
            if (!(-4611686018426999999n <= containsArg ? containsArg <= 4611686018426999999n : false))
              throw AssertionError().ze(_get_value__a43j40($this$apply).toString() + ' ns is out of nanoseconds range');
          } else {
            var tmp;
            // Inline function 'kotlin.time.isFiniteMillis' call
            var this_1 = _get_value__a43j40($this$apply);
            if (!(-4611686018427387903n < this_1 && this_1 < 4611686018427387903n)) {
              // Inline function 'kotlin.time.isInfiniteMillis' call
              var this_2 = _get_value__a43j40($this$apply);
              tmp = !(this_2 === 4611686018427387903n || this_2 === -4611686018427387903n);
            } else {
              tmp = false;
            }
            if (tmp)
              throw AssertionError().ze(_get_value__a43j40($this$apply).toString() + ' ms is out of milliseconds range');
            var containsArg_0 = _get_value__a43j40($this$apply);
            if (-4611686018426n <= containsArg_0 ? containsArg_0 <= 4611686018426n : false)
              throw AssertionError().ze(_get_value__a43j40($this$apply).toString() + ' ms is denormalized');
          }
        }
        return this_0.ji_1;
      }
      es(value) {
        var tmp;
        try {
          // Inline function 'kotlin.apply' call
          var this_0 = new (Duration())(parseDuration(value, false));
          var $this$apply = this_0.ji_1;
          // Inline function 'kotlin.check' call
          if (!!equals(new (Duration())($this$apply), new (Duration())(Companion_getInstance().oi_1))) {
            var message = 'invariant failed';
            throw IllegalStateException().o(toString(message));
          }
          tmp = this_0.ji_1;
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw IllegalArgumentException().vd("Invalid duration string format: '" + value + "'.", e);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      fs(value) {
        var tmp;
        try {
          // Inline function 'kotlin.apply' call
          var this_0 = new (Duration())(parseDuration(value, true));
          var $this$apply = this_0.ji_1;
          // Inline function 'kotlin.check' call
          if (!!equals(new (Duration())($this$apply), new (Duration())(Companion_getInstance().oi_1))) {
            var message = 'invariant failed';
            throw IllegalStateException().o(toString(message));
          }
          tmp = this_0.ji_1;
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw IllegalArgumentException().vd("Invalid ISO duration string format: '" + value + "'.", e);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Duration__unaryMinus_impl_x2k1y0($this) {
  var tmp = negate(_get_value__a43j40($this));
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  var tmp$ret$0 = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
  return durationOf(tmp, tmp$ret$0);
}
function Duration__plus_impl_yu9v8f($this, other) {
  var tmp;
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  var tmp_0 = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  if (tmp_0 === (convertToInt(_get_rawValue__5zfu4e(other)) & 1)) {
    var tmp_1;
    if (isInNanos($this)) {
      tmp_1 = durationOfNanosNormalized(add(_get_value__a43j40($this), _get_value__a43j40(other)));
    } else {
      // Inline function 'kotlin.let' call
      var it = addMillisWithoutOverflow(_get_value__a43j40($this), _get_value__a43j40(other));
      var tmp_2;
      if (it === 9223372036854759646n) {
        throw IllegalArgumentException().o2('Summing infinite durations of different signs yields an undefined result.');
      } else {
        // Inline function 'kotlin.time.isInfiniteMillis' call
        if (it === 4611686018427387903n || it === -4611686018427387903n) {
          tmp_2 = durationOfMillis(it);
        } else {
          tmp_2 = durationOfMillisNormalized(it);
        }
      }
      tmp_1 = tmp_2;
    }
    tmp = tmp_1;
  } else {
    if (isInMillis($this)) {
      tmp = addValuesMixedRanges($this, _get_value__a43j40($this), _get_value__a43j40(other));
    } else {
      tmp = addValuesMixedRanges($this, _get_value__a43j40(other), _get_value__a43j40($this));
    }
  }
  return tmp;
}
function addValuesMixedRanges($this, thisMillis, otherNanos) {
  var otherMillis = nanosToMillis(otherNanos);
  var resultMillis = addMillisWithoutOverflow(thisMillis, otherMillis);
  var tmp;
  if (-4611686018426n <= resultMillis ? resultMillis <= 4611686018426n : false) {
    var otherNanoRemainder = subtract(otherNanos, millisToNanos(otherMillis));
    tmp = durationOfNanos(add(millisToNanos(resultMillis), otherNanoRemainder));
  } else {
    tmp = durationOfMillis(resultMillis);
  }
  return tmp;
}
function Duration__isNegative_impl_pbysfa($this) {
  return _get_rawValue__5zfu4e($this) < 0n;
}
function Duration__isPositive_impl_tvkkt2($this) {
  return _get_rawValue__5zfu4e($this) > 0n;
}
function Duration__isInfinite_impl_tsn9y3($this) {
  return _get_rawValue__5zfu4e($this) === _get_rawValue__5zfu4e(Companion_getInstance().li_1) || _get_rawValue__5zfu4e($this) === _get_rawValue__5zfu4e(Companion_getInstance().mi_1);
}
function Duration__isFinite_impl_rzjsps($this) {
  return !Duration__isInfinite_impl_tsn9y3($this);
}
function _Duration___get_absoluteValue__impl__vr7i6w($this) {
  return Duration__isNegative_impl_pbysfa($this) ? Duration__unaryMinus_impl_x2k1y0($this) : $this;
}
function Duration__compareTo_impl_pchp0f($this, other) {
  var compareBits = _get_rawValue__5zfu4e($this) ^ _get_rawValue__5zfu4e(other);
  if (compareBits < 0n || (convertToInt(compareBits) & 1) === 0)
    return compareTo(_get_rawValue__5zfu4e($this), _get_rawValue__5zfu4e(other));
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  var tmp = convertToInt(_get_rawValue__5zfu4e($this)) & 1;
  // Inline function 'kotlin.time.Duration.unitDiscriminator' call
  var r = tmp - (convertToInt(_get_rawValue__5zfu4e(other)) & 1) | 0;
  return Duration__isNegative_impl_pbysfa($this) ? -r | 0 : r;
}
function Duration__compareTo_impl_pchp0f_0($this, other) {
  return Duration__compareTo_impl_pchp0f($this.ji_1, other instanceof Duration() ? other.ji_1 : THROW_CCE());
}
function _Duration___get_hoursComponent__impl__7hllxa($this) {
  var tmp;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    tmp = 0;
  } else {
    // Inline function 'kotlin.Long.rem' call
    var this_0 = _Duration___get_inWholeHours__impl__kb9f3j($this);
    var tmp$ret$0 = modulo(this_0, fromInt(24));
    tmp = convertToInt(tmp$ret$0);
  }
  return tmp;
}
function _Duration___get_minutesComponent__impl__ctvd8u($this) {
  var tmp;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    tmp = 0;
  } else {
    // Inline function 'kotlin.Long.rem' call
    var this_0 = _Duration___get_inWholeMinutes__impl__dognoh($this);
    var tmp$ret$0 = modulo(this_0, fromInt(60));
    tmp = convertToInt(tmp$ret$0);
  }
  return tmp;
}
function _Duration___get_secondsComponent__impl__if34a6($this) {
  var tmp;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    tmp = 0;
  } else {
    // Inline function 'kotlin.Long.rem' call
    var this_0 = _Duration___get_inWholeSeconds__impl__hpy7b3($this);
    var tmp$ret$0 = modulo(this_0, fromInt(60));
    tmp = convertToInt(tmp$ret$0);
  }
  return tmp;
}
function _Duration___get_nanosecondsComponent__impl__nh19kq($this) {
  var tmp;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    tmp = 0;
  } else if (isInMillis($this)) {
    // Inline function 'kotlin.Long.rem' call
    var this_0 = _get_value__a43j40($this);
    var tmp$ret$0 = modulo(this_0, fromInt(1000));
    tmp = convertToInt(millisToNanos(tmp$ret$0));
  } else {
    var tmp0 = _get_value__a43j40($this);
    // Inline function 'kotlin.Long.rem' call
    var other = 1000000000;
    var tmp$ret$1 = modulo(tmp0, fromInt(other));
    tmp = convertToInt(tmp$ret$1);
  }
  return tmp;
}
function Duration__toDouble_impl_a56y2b($this, unit) {
  var tmp0_subject = _get_rawValue__5zfu4e($this);
  var tmp;
  if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().li_1)) {
    tmp = Infinity;
  } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().mi_1)) {
    tmp = -Infinity;
  } else {
    tmp = convertDurationUnit(toNumber(_get_value__a43j40($this)), _get_storageUnit__szjgha($this), unit);
  }
  return tmp;
}
function Duration__toLong_impl_shr43i($this, unit) {
  var tmp0_subject = _get_rawValue__5zfu4e($this);
  return tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().li_1) ? 9223372036854775807n : tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().mi_1) ? -9223372036854775808n : convertDurationUnit_0(_get_value__a43j40($this), _get_storageUnit__szjgha($this), unit);
}
function Duration__toInt_impl_nnev71($this, unit) {
  return convertToInt(coerceIn(Duration__toLong_impl_shr43i($this, unit), -2147483648n, 2147483647n));
}
function _Duration___get_inWholeDays__impl__7bvpxz($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_DAYS_getInstance());
}
function _Duration___get_inWholeHours__impl__kb9f3j($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_HOURS_getInstance());
}
function _Duration___get_inWholeMinutes__impl__dognoh($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_MINUTES_getInstance());
}
function _Duration___get_inWholeSeconds__impl__hpy7b3($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_SECONDS_getInstance());
}
function _Duration___get_inWholeMilliseconds__impl__msfiry($this) {
  return isInMillis($this) && Duration__isFinite_impl_rzjsps($this) ? _get_value__a43j40($this) : Duration__toLong_impl_shr43i($this, DurationUnit_MILLISECONDS_getInstance());
}
function _Duration___get_inWholeMicroseconds__impl__8oe8vv($this) {
  return Duration__toLong_impl_shr43i($this, DurationUnit_MICROSECONDS_getInstance());
}
function Duration__toString_impl_8d916b($this) {
  var tmp0_subject = _get_rawValue__5zfu4e($this);
  var tmp;
  if (tmp0_subject === 0n) {
    tmp = '0s';
  } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().li_1)) {
    tmp = 'Infinity';
  } else if (tmp0_subject === _get_rawValue__5zfu4e(Companion_getInstance().mi_1)) {
    tmp = '-Infinity';
  } else {
    var isNegative = Duration__isNegative_impl_pbysfa($this);
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder().l1();
    if (isNegative) {
      this_0.o1(_Char___init__impl__6a9atx(45));
    }
    // Inline function 'kotlin.time.Duration.toComponents' call
    var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
    var tmp0 = _Duration___get_inWholeDays__impl__7bvpxz(this_1);
    var tmp2 = _Duration___get_hoursComponent__impl__7hllxa(this_1);
    var tmp4 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
    var tmp6 = _Duration___get_secondsComponent__impl__if34a6(this_1);
    var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
    var hasDays = !(tmp0 === 0n);
    var hasHours = !(tmp2 === 0);
    var hasMinutes = !(tmp4 === 0);
    var hasSeconds = !(tmp6 === 0) || !(nanoseconds === 0);
    var components = 0;
    if (hasDays) {
      this_0.bh(tmp0).o1(_Char___init__impl__6a9atx(100));
      components = components + 1 | 0;
    }
    if (hasHours || (hasDays && (hasMinutes || hasSeconds))) {
      var _unary__edvuaz = components;
      components = _unary__edvuaz + 1 | 0;
      if (_unary__edvuaz > 0) {
        this_0.o1(_Char___init__impl__6a9atx(32));
      }
      this_0.ah(tmp2).o1(_Char___init__impl__6a9atx(104));
    }
    if (hasMinutes || (hasSeconds && (hasHours || hasDays))) {
      var _unary__edvuaz_0 = components;
      components = _unary__edvuaz_0 + 1 | 0;
      if (_unary__edvuaz_0 > 0) {
        this_0.o1(_Char___init__impl__6a9atx(32));
      }
      this_0.ah(tmp4).o1(_Char___init__impl__6a9atx(109));
    }
    if (hasSeconds) {
      var _unary__edvuaz_1 = components;
      components = _unary__edvuaz_1 + 1 | 0;
      if (_unary__edvuaz_1 > 0) {
        this_0.o1(_Char___init__impl__6a9atx(32));
      }
      if (!(tmp6 === 0) || hasDays || hasHours || hasMinutes) {
        appendFractional($this, this_0, tmp6, nanoseconds, 9, 's', false);
      } else if (nanoseconds >= 1000000) {
        appendFractional($this, this_0, nanoseconds / 1000000 | 0, nanoseconds % 1000000 | 0, 6, 'ms', false);
      } else if (nanoseconds >= 1000) {
        appendFractional($this, this_0, nanoseconds / 1000 | 0, nanoseconds % 1000 | 0, 3, 'us', false);
      } else
        this_0.ah(nanoseconds).m1('ns');
    }
    if (isNegative && components > 1) {
      this_0.ch(1, _Char___init__impl__6a9atx(40)).o1(_Char___init__impl__6a9atx(41));
    }
    tmp = this_0.toString();
  }
  return tmp;
}
function appendFractional($this, $receiver, whole, fractional, fractionalSize, unit, isoZeroes) {
  $receiver.ah(whole);
  if (!(fractional === 0)) {
    $receiver.o1(_Char___init__impl__6a9atx(46));
    var fracString = padStart(fractional.toString(), fractionalSize, _Char___init__impl__6a9atx(48));
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.text.indexOfLast' call
      var inductionVariable = charSequenceLength(fracString) - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          if (!(charSequenceGet(fracString, index) === _Char___init__impl__6a9atx(48))) {
            tmp$ret$0 = index;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$0 = -1;
    }
    var nonZeroDigits = tmp$ret$0 + 1 | 0;
    if (!isoZeroes && nonZeroDigits < 3) {
      // Inline function 'kotlin.text.appendRange' call
      $receiver.yg(fracString, 0, nonZeroDigits);
    } else {
      // Inline function 'kotlin.text.appendRange' call
      var endIndex = imul((nonZeroDigits + 2 | 0) / 3 | 0, 3);
      $receiver.yg(fracString, 0, endIndex);
    }
  }
  $receiver.m1(unit);
}
function Duration__toIsoString_impl_9h6wsm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().l1();
  if (Duration__isNegative_impl_pbysfa($this)) {
    this_0.o1(_Char___init__impl__6a9atx(45));
  }
  this_0.m1('PT');
  // Inline function 'kotlin.time.Duration.toComponents' call
  var this_1 = _Duration___get_absoluteValue__impl__vr7i6w($this);
  var tmp0 = _Duration___get_inWholeHours__impl__kb9f3j(this_1);
  var tmp2 = _Duration___get_minutesComponent__impl__ctvd8u(this_1);
  var tmp4 = _Duration___get_secondsComponent__impl__if34a6(this_1);
  var nanoseconds = _Duration___get_nanosecondsComponent__impl__nh19kq(this_1);
  var hours = tmp0;
  if (Duration__isInfinite_impl_tsn9y3($this)) {
    hours = 9999999999999n;
  }
  var hasHours = !(hours === 0n);
  var hasSeconds = !(tmp4 === 0) || !(nanoseconds === 0);
  var hasMinutes = !(tmp2 === 0) || (hasSeconds && hasHours);
  if (hasHours) {
    this_0.bh(hours).o1(_Char___init__impl__6a9atx(72));
  }
  if (hasMinutes) {
    this_0.ah(tmp2).o1(_Char___init__impl__6a9atx(77));
  }
  if (hasSeconds || (!hasHours && !hasMinutes)) {
    appendFractional($this, this_0, tmp4, nanoseconds, 9, 'S', true);
  }
  return this_0.toString();
}
function Duration__hashCode_impl_u4exz6($this) {
  return getBigIntHashCode($this);
}
function Duration__equals_impl_ygj6w6($this, other) {
  if (!(other instanceof Duration()))
    return false;
  if (!($this === other.ji_1))
    return false;
  return true;
}
var DurationClass;
function Duration() {
  if (DurationClass === VOID) {
    class $ {
      constructor(rawValue) {
        Companion_getInstance();
        this.ji_1 = rawValue;
      }
      gs(other) {
        return Duration__compareTo_impl_pchp0f(this.ji_1, other);
      }
      d(other) {
        return Duration__compareTo_impl_pchp0f_0(this, other);
      }
      toString() {
        return Duration__toString_impl_8d916b(this.ji_1);
      }
      hashCode() {
        return Duration__hashCode_impl_u4exz6(this.ji_1);
      }
      equals(other) {
        return Duration__equals_impl_ygj6w6(this.ji_1, other);
      }
    }
    initMetadataForClass($, 'Duration', VOID, VOID, [Comparable()]);
    DurationClass = $;
  }
  return DurationClass;
}
function durationOfMillis(normalMillis) {
  var tmp = Companion_getInstance();
  // Inline function 'kotlin.Long.plus' call
  var this_0 = shiftLeft(normalMillis, 1);
  var tmp$ret$0 = add(this_0, fromInt(1));
  return tmp.ds(tmp$ret$0);
}
function toDuration(_this__u8e3s4, unit) {
  var tmp;
  if (unit.e5(DurationUnit_SECONDS_getInstance()) <= 0) {
    tmp = durationOfNanos(convertDurationUnitOverflow(fromInt(_this__u8e3s4), unit, DurationUnit_NANOSECONDS_getInstance()));
  } else {
    tmp = toDuration_0(fromInt(_this__u8e3s4), unit);
  }
  return tmp;
}
function toDuration_0(_this__u8e3s4, unit) {
  var maxNsInUnit = convertDurationUnitOverflow(4611686018426999999n, DurationUnit_NANOSECONDS_getInstance(), unit);
  var tmp;
  if (negate(maxNsInUnit) <= _this__u8e3s4 ? _this__u8e3s4 <= maxNsInUnit : false) {
    tmp = durationOfNanos(convertDurationUnitOverflow(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance()));
  } else if (unit.e5(DurationUnit_MILLISECONDS_getInstance()) >= 0) {
    var tmp_0 = get_sign(_this__u8e3s4);
    // Inline function 'kotlin.Long.plus' call
    var this_0 = -9223372036854775808n;
    var tmp$ret$0 = add(this_0, fromInt(1));
    tmp = durationOfMillis(multiply(numberToLong(tmp_0), convertDurationUnitToMilliseconds(abs(coerceAtLeast(_this__u8e3s4, tmp$ret$0)), unit)));
  } else {
    tmp = durationOfMillis(coerceIn(convertDurationUnit_0(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()), -4611686018427387903n, 4611686018427387903n));
  }
  return tmp;
}
function toDuration_1(_this__u8e3s4, unit) {
  var valueInNs = convertDurationUnit(_this__u8e3s4, unit, DurationUnit_NANOSECONDS_getInstance());
  // Inline function 'kotlin.require' call
  if (!!isNaN_0(valueInNs)) {
    var message = 'Duration value cannot be NaN.';
    throw IllegalArgumentException().o2(toString(message));
  }
  var nanos = roundToLong(valueInNs);
  var tmp;
  if (-4611686018426999999n <= nanos ? nanos <= 4611686018426999999n : false) {
    tmp = durationOfNanos(nanos);
  } else {
    var millis = roundToLong(convertDurationUnit(_this__u8e3s4, unit, DurationUnit_MILLISECONDS_getInstance()));
    tmp = durationOfMillisNormalized(millis);
  }
  return tmp;
}
function parseDuration(value, strictIso, throwException) {
  throwException = throwException === VOID ? true : throwException;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    // Inline function 'kotlin.time.handleError' call
    var message = 'The string is empty';
    if (throwException)
      throw IllegalArgumentException().o2(message);
    return Companion_getInstance().oi_1;
  }
  var index = 0;
  var firstChar = charCodeAt(value, index);
  var isNegative = false;
  if (firstChar === _Char___init__impl__6a9atx(45)) {
    isNegative = true;
    index = index + 1 | 0;
  } else if (firstChar === _Char___init__impl__6a9atx(43)) {
    index = index + 1 | 0;
  }
  var hasSign = index > 0;
  var tmp;
  if (value.length <= index) {
    // Inline function 'kotlin.time.handleError' call
    var message_0 = 'No components';
    if (throwException)
      throw IllegalArgumentException().o2(message_0);
    return Companion_getInstance().oi_1;
  } else {
    if (charCodeAt(value, index) === _Char___init__impl__6a9atx(80)) {
      tmp = parseIsoStringFormat(value, index + 1 | 0, throwException);
    } else {
      if (strictIso) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      } else {
        var tmp_0 = index;
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = value.length - index | 0;
        var tmp$ret$4 = Math.max(a, 8);
        if (regionMatches(value, tmp_0, 'Infinity', 0, tmp$ret$4, true)) {
          tmp = Companion_getInstance().li_1;
        } else {
          tmp = parseDefaultStringFormat(value, index, hasSign, throwException);
        }
      }
    }
  }
  var result = tmp;
  return isNegative && !equals(new (Duration())(result), new (Duration())(Companion_getInstance().oi_1)) ? Duration__unaryMinus_impl_x2k1y0(result) : result;
}
function durationOf(normalValue, unitDiscriminator) {
  var tmp = Companion_getInstance();
  // Inline function 'kotlin.Long.plus' call
  var this_0 = shiftLeft(normalValue, 1);
  var tmp$ret$0 = add(this_0, fromInt(unitDiscriminator));
  return tmp.ds(tmp$ret$0);
}
function durationOfNanosNormalized(nanos) {
  var tmp;
  if (-4611686018426999999n <= nanos ? nanos <= 4611686018426999999n : false) {
    tmp = durationOfNanos(nanos);
  } else {
    tmp = durationOfMillis(nanosToMillis(nanos));
  }
  return tmp;
}
function addMillisWithoutOverflow(_this__u8e3s4, other) {
  var tmp;
  // Inline function 'kotlin.time.isInfiniteMillis' call
  if (_this__u8e3s4 === 4611686018427387903n || _this__u8e3s4 === -4611686018427387903n) {
    var tmp_0;
    var tmp_1;
    // Inline function 'kotlin.time.isFiniteMillis' call
    if (-4611686018427387903n < other && other < 4611686018427387903n) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.time.sameSign' call
      tmp_1 = (_this__u8e3s4 ^ other) >= 0n;
    }
    if (tmp_1) {
      tmp_0 = _this__u8e3s4;
    } else {
      tmp_0 = 9223372036854759646n;
    }
    tmp = tmp_0;
  } else {
    // Inline function 'kotlin.time.isInfiniteMillis' call
    if (other === 4611686018427387903n || other === -4611686018427387903n) {
      tmp = other;
    } else {
      tmp = coerceIn(add(_this__u8e3s4, other), -4611686018427387903n, 4611686018427387903n);
    }
  }
  return tmp;
}
function durationOfMillisNormalized(millis) {
  var tmp;
  if (-4611686018426n <= millis ? millis <= 4611686018426n : false) {
    tmp = durationOfNanos(millisToNanos(millis));
  } else {
    tmp = durationOfMillis(coerceIn(millis, -4611686018427387903n, 4611686018427387903n));
  }
  return tmp;
}
function nanosToMillis(nanos) {
  // Inline function 'kotlin.Long.div' call
  return divide(nanos, fromInt(1000000));
}
function millisToNanos(millis) {
  // Inline function 'kotlin.Long.times' call
  return multiply(millis, fromInt(1000000));
}
function durationOfNanos(normalNanos) {
  return Companion_getInstance().ds(shiftLeft(normalNanos, 1));
}
function parseIsoStringFormat(value, startIndex, throwException) {
  var index = startIndex;
  if (index === value.length) {
    // Inline function 'kotlin.time.handleError' call
    if (throwException)
      throw IllegalArgumentException().o2('');
    return Companion_getInstance().oi_1;
  }
  var totalMillis = 0n;
  var totalNanos = 0n;
  var isTimeComponent = false;
  var prevUnit = null;
  $l$loop: while (index < value.length) {
    var ch = charCodeAt(value, index);
    if (ch === _Char___init__impl__6a9atx(84)) {
      var tmp;
      if (isTimeComponent) {
        tmp = true;
      } else {
        index = index + 1 | 0;
        tmp = index === value.length;
      }
      if (tmp) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      isTimeComponent = true;
      continue $l$loop;
    }
    var longStartIndex = index;
    var sign;
    var tmp0 = Companion_getInstance_0().hs_1;
    var tmp4 = index;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.time.LongParser.parse' call
      var sign_0 = 1;
      var index_0 = tmp4;
      if (access$_get_allowSign__e988q3(tmp0)) {
        var firstChar = charCodeAt(value, index_0);
        if (firstChar === _Char___init__impl__6a9atx(45)) {
          sign_0 = -1;
          index_0 = index_0 + 1 | 0;
        } else if (firstChar === _Char___init__impl__6a9atx(43)) {
          index_0 = index_0 + 1 | 0;
        }
      }
      // Inline function 'kotlin.text.skipWhile' call
      var i = index_0;
      $l$loop_0: while (true) {
        var tmp_0;
        if (i < value.length) {
          tmp_0 = charCodeAt(value, i) === _Char___init__impl__6a9atx(48);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          break $l$loop_0;
        }
        i = i + 1 | 0;
      }
      index_0 = i;
      var result = 0n;
      $l$loop_1: while (index_0 < value.length) {
        var ch_0 = charCodeAt(value, index_0);
        if (!(_Char___init__impl__6a9atx(48) <= ch_0 ? ch_0 <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_1;
        var digit = Char__minus_impl_a2frrh(ch_0, _Char___init__impl__6a9atx(48));
        if (result > access$_get_overflowThreshold__7yqffs(tmp0) || (result === access$_get_overflowThreshold__7yqffs(tmp0) && fromInt(digit) > access$_get_lastDigitMax__85wg2(tmp0))) {
          // Inline function 'kotlin.text.skipWhile' call
          var i_0 = index_0;
          $l$loop_2: while (true) {
            var tmp_1;
            if (i_0 < value.length) {
              var it = charCodeAt(value, i_0);
              tmp_1 = _Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false;
            } else {
              tmp_1 = false;
            }
            if (!tmp_1) {
              break $l$loop_2;
            }
            i_0 = i_0 + 1 | 0;
          }
          index_0 = i_0;
          var tmp0_0 = index_0;
          var localSign = sign_0;
          index = tmp0_0;
          if (index === value.length || index === (longStartIndex + (ch === _Char___init__impl__6a9atx(45) || ch === _Char___init__impl__6a9atx(43) ? 1 : 0) | 0)) {
            // Inline function 'kotlin.time.handleError' call
            if (throwException)
              throw IllegalArgumentException().o2('');
            return Companion_getInstance().oi_1;
          }
          sign = localSign;
          tmp$ret$2 = access$_get_overflowLimit__t4uhig(tmp0);
          break $l$block;
        }
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_0 = result;
        // Inline function 'kotlin.Long.plus' call
        var this_1 = add(shiftLeft(this_0, 3), shiftLeft(this_0, 1));
        result = add(this_1, fromInt(digit));
        index_0 = index_0 + 1 | 0;
      }
      var tmp0_1 = index_0;
      var localSign_0 = sign_0;
      index = tmp0_1;
      if (index === value.length || index === (longStartIndex + (ch === _Char___init__impl__6a9atx(45) || ch === _Char___init__impl__6a9atx(43) ? 1 : 0) | 0)) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      sign = localSign_0;
      tmp$ret$2 = result;
    }
    var longValue = tmp$ret$2;
    if (charCodeAt(value, index) === _Char___init__impl__6a9atx(46)) {
      index = index + 1 | 0;
      // Inline function 'kotlin.time.FractionalParser.parse' call
      var index_1 = index;
      // Inline function 'kotlin.time.FractionalParser.parseDigits' call
      var startIndex_0 = index_1;
      var index_2 = startIndex_0;
      var tmp0_2 = index_2 + 6 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = value.length;
      var endIndex = Math.min(tmp0_2, b);
      var result_0 = 0;
      $l$loop_3: while (index_2 < endIndex) {
        var ch_1 = charCodeAt(value, index_2);
        if (!(_Char___init__impl__6a9atx(48) <= ch_1 ? ch_1 <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_3;
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_2 = result_0;
        result_0 = ((this_2 << 3) + (this_2 << 1) | 0) + Char__minus_impl_a2frrh(ch_1, _Char___init__impl__6a9atx(48)) | 0;
        index_2 = index_2 + 1 | 0;
      }
      // Inline function 'kotlin.repeat' call
      var times = 6 - (index_2 - startIndex_0 | 0) | 0;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.time.multiplyBy10' call
          var this_3 = result_0;
          result_0 = (this_3 << 3) + (this_3 << 1) | 0;
        }
         while (inductionVariable < times);
      index_1 = index_2;
      var highPrecisionDigits = result_0;
      // Inline function 'kotlin.time.FractionalParser.parseDigits' call
      var startIndex_1 = index_1;
      var index_4 = startIndex_1;
      var tmp0_3 = index_4 + 9 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = value.length;
      var endIndex_0 = Math.min(tmp0_3, b_0);
      var result_1 = 0;
      $l$loop_4: while (index_4 < endIndex_0) {
        var ch_2 = charCodeAt(value, index_4);
        if (!(_Char___init__impl__6a9atx(48) <= ch_2 ? ch_2 <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_4;
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_4 = result_1;
        result_1 = ((this_4 << 3) + (this_4 << 1) | 0) + Char__minus_impl_a2frrh(ch_2, _Char___init__impl__6a9atx(48)) | 0;
        index_4 = index_4 + 1 | 0;
      }
      // Inline function 'kotlin.repeat' call
      var times_0 = 9 - (index_4 - startIndex_1 | 0) | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < times_0)
        do {
          var index_5 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.time.multiplyBy10' call
          var this_5 = result_1;
          result_1 = (this_5 << 3) + (this_5 << 1) | 0;
        }
         while (inductionVariable_0 < times_0);
      index_1 = index_4;
      var lowPrecisionDigits = result_1;
      // Inline function 'kotlin.text.skipWhile' call
      var i_1 = index_1;
      $l$loop_5: while (true) {
        var tmp_2;
        if (i_1 < value.length) {
          var it_0 = charCodeAt(value, i_1);
          tmp_2 = _Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false;
        } else {
          tmp_2 = false;
        }
        if (!tmp_2) {
          break $l$loop_5;
        }
        i_1 = i_1 + 1 | 0;
      }
      index_1 = i_1;
      var fractionEndIndex = index_1;
      if (fractionEndIndex === index || fractionEndIndex === value.length || !(charCodeAt(value, fractionEndIndex) === _Char___init__impl__6a9atx(83))) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      index = fractionEndIndex;
      var tmp0_4 = fromInt(highPrecisionDigits);
      // Inline function 'kotlin.Long.times' call
      var other = 1000000000;
      // Inline function 'kotlin.Long.plus' call
      var this_6 = multiply(tmp0_4, fromInt(other));
      var fractionValue = add(this_6, fromInt(lowPrecisionDigits));
      totalNanos = multiply(numberToLong(sign), fractionDigitsToNanos(fractionValue, DurationUnit_SECONDS_getInstance()));
    }
    var tmp0_elvis_lhs = isoDurationUnitByShortNameOrNull(value, index);
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.time.handleError' call
      var message = 'Unknown duration unit short name: ' + toString_0(charCodeAt(value, index));
      if (throwException)
        throw IllegalArgumentException().o2(message);
      return Companion_getInstance().oi_1;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var unit = tmp_3;
    if (!(prevUnit == null) && prevUnit.e5(unit) <= 0) {
      // Inline function 'kotlin.time.handleError' call
      var message_0 = 'Unexpected order of duration components';
      if (throwException)
        throw IllegalArgumentException().o2(message_0);
      return Companion_getInstance().oi_1;
    }
    prevUnit = unit;
    if (unit.equals(DurationUnit_DAYS_getInstance())) {
      if (isTimeComponent) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      totalMillis = multiply(numberToLong(sign), convertDurationUnitToMilliseconds(longValue, unit));
    } else {
      if (!isTimeComponent) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      // Inline function 'kotlin.also' call
      var this_7 = addMillisWithoutOverflow(totalMillis, multiply(numberToLong(sign), convertDurationUnitToMilliseconds(longValue, unit)));
      if (this_7 === 9223372036854759646n) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      totalMillis = this_7;
    }
    index = index + 1 | 0;
  }
  return Duration__plus_impl_yu9v8f(toDuration_0(totalMillis, DurationUnit_MILLISECONDS_getInstance()), toDuration_0(totalNanos, DurationUnit_NANOSECONDS_getInstance()));
}
function parseDefaultStringFormat(value, startIndex, hasSign, throwException) {
  var index = startIndex;
  var length = value.length;
  var allowSpaces = !hasSign;
  if (hasSign && charCodeAt(value, index) === _Char___init__impl__6a9atx(40) && charCodeAt(value, length - 1 | 0) === _Char___init__impl__6a9atx(41)) {
    allowSpaces = true;
    index = index + 1 | 0;
    length = length - 1 | 0;
    if (index === length) {
      // Inline function 'kotlin.time.handleError' call
      var message = 'No components';
      if (throwException)
        throw IllegalArgumentException().o2(message);
      return Companion_getInstance().oi_1;
    }
  }
  var totalMillis = 0n;
  var totalNanos = 0n;
  var prevUnit = null;
  var isFirstComponent = true;
  while (index < length) {
    if (!isFirstComponent && allowSpaces) {
      // Inline function 'kotlin.text.skipWhile' call
      var i = index;
      $l$loop: while (true) {
        var tmp;
        if (i < value.length) {
          tmp = charCodeAt(value, i) === _Char___init__impl__6a9atx(32);
        } else {
          tmp = false;
        }
        if (!tmp) {
          break $l$loop;
        }
        i = i + 1 | 0;
      }
      index = i;
    }
    isFirstComponent = false;
    var longStartIndex = index;
    var tmp0 = Companion_getInstance_0().is_1;
    var tmp4 = index;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.time.LongParser.parse' call
      var sign = 1;
      var index_0 = tmp4;
      if (access$_get_allowSign__e988q3(tmp0)) {
        var firstChar = charCodeAt(value, index_0);
        if (firstChar === _Char___init__impl__6a9atx(45)) {
          sign = -1;
          index_0 = index_0 + 1 | 0;
        } else if (firstChar === _Char___init__impl__6a9atx(43)) {
          index_0 = index_0 + 1 | 0;
        }
      }
      // Inline function 'kotlin.text.skipWhile' call
      var i_0 = index_0;
      $l$loop_0: while (true) {
        var tmp_0;
        if (i_0 < value.length) {
          tmp_0 = charCodeAt(value, i_0) === _Char___init__impl__6a9atx(48);
        } else {
          tmp_0 = false;
        }
        if (!tmp_0) {
          break $l$loop_0;
        }
        i_0 = i_0 + 1 | 0;
      }
      index_0 = i_0;
      var result = 0n;
      $l$loop_1: while (index_0 < value.length) {
        var ch = charCodeAt(value, index_0);
        if (!(_Char___init__impl__6a9atx(48) <= ch ? ch <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_1;
        var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
        if (result > access$_get_overflowThreshold__7yqffs(tmp0) || (result === access$_get_overflowThreshold__7yqffs(tmp0) && fromInt(digit) > access$_get_lastDigitMax__85wg2(tmp0))) {
          // Inline function 'kotlin.text.skipWhile' call
          var i_1 = index_0;
          $l$loop_2: while (true) {
            var tmp_1;
            if (i_1 < value.length) {
              var it = charCodeAt(value, i_1);
              tmp_1 = _Char___init__impl__6a9atx(48) <= it ? it <= _Char___init__impl__6a9atx(57) : false;
            } else {
              tmp_1 = false;
            }
            if (!tmp_1) {
              break $l$loop_2;
            }
            i_1 = i_1 + 1 | 0;
          }
          index_0 = i_1;
          var tmp0_0 = index_0;
          if (tmp0_0 === longStartIndex || tmp0_0 === length || true) {
            // Inline function 'kotlin.time.handleError' call
            if (throwException)
              throw IllegalArgumentException().o2('');
            return Companion_getInstance().oi_1;
          }
          index = tmp0_0;
          tmp$ret$3 = access$_get_overflowLimit__t4uhig(tmp0);
          break $l$block;
        }
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_0 = result;
        // Inline function 'kotlin.Long.plus' call
        var this_1 = add(shiftLeft(this_0, 3), shiftLeft(this_0, 1));
        result = add(this_1, fromInt(digit));
        index_0 = index_0 + 1 | 0;
      }
      var tmp0_1 = index_0;
      if (tmp0_1 === longStartIndex || tmp0_1 === length || false) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      index = tmp0_1;
      tmp$ret$3 = result;
    }
    var longValue = tmp$ret$3;
    var hasFractionalPart = charCodeAt(value, index) === _Char___init__impl__6a9atx(46);
    var fractionStartIndex;
    var fractionValue;
    if (hasFractionalPart) {
      fractionStartIndex = index;
      index = index + 1 | 0;
      // Inline function 'kotlin.time.FractionalParser.parse' call
      var index_1 = index;
      // Inline function 'kotlin.time.FractionalParser.parseDigits' call
      var startIndex_0 = index_1;
      var index_2 = startIndex_0;
      var tmp0_2 = index_2 + 6 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = value.length;
      var endIndex = Math.min(tmp0_2, b);
      var result_0 = 0;
      $l$loop_3: while (index_2 < endIndex) {
        var ch_0 = charCodeAt(value, index_2);
        if (!(_Char___init__impl__6a9atx(48) <= ch_0 ? ch_0 <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_3;
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_2 = result_0;
        result_0 = ((this_2 << 3) + (this_2 << 1) | 0) + Char__minus_impl_a2frrh(ch_0, _Char___init__impl__6a9atx(48)) | 0;
        index_2 = index_2 + 1 | 0;
      }
      // Inline function 'kotlin.repeat' call
      var times = 6 - (index_2 - startIndex_0 | 0) | 0;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index_3 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.time.multiplyBy10' call
          var this_3 = result_0;
          result_0 = (this_3 << 3) + (this_3 << 1) | 0;
        }
         while (inductionVariable < times);
      index_1 = index_2;
      var highPrecisionDigits = result_0;
      // Inline function 'kotlin.time.FractionalParser.parseDigits' call
      var startIndex_1 = index_1;
      var index_4 = startIndex_1;
      var tmp0_3 = index_4 + 9 | 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var b_0 = value.length;
      var endIndex_0 = Math.min(tmp0_3, b_0);
      var result_1 = 0;
      $l$loop_4: while (index_4 < endIndex_0) {
        var ch_1 = charCodeAt(value, index_4);
        if (!(_Char___init__impl__6a9atx(48) <= ch_1 ? ch_1 <= _Char___init__impl__6a9atx(57) : false))
          break $l$loop_4;
        // Inline function 'kotlin.time.multiplyBy10' call
        var this_4 = result_1;
        result_1 = ((this_4 << 3) + (this_4 << 1) | 0) + Char__minus_impl_a2frrh(ch_1, _Char___init__impl__6a9atx(48)) | 0;
        index_4 = index_4 + 1 | 0;
      }
      // Inline function 'kotlin.repeat' call
      var times_0 = 9 - (index_4 - startIndex_1 | 0) | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < times_0)
        do {
          var index_5 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.time.multiplyBy10' call
          var this_5 = result_1;
          result_1 = (this_5 << 3) + (this_5 << 1) | 0;
        }
         while (inductionVariable_0 < times_0);
      index_1 = index_4;
      var lowPrecisionDigits = result_1;
      // Inline function 'kotlin.text.skipWhile' call
      var i_2 = index_1;
      $l$loop_5: while (true) {
        var tmp_2;
        if (i_2 < value.length) {
          var it_0 = charCodeAt(value, i_2);
          tmp_2 = _Char___init__impl__6a9atx(48) <= it_0 ? it_0 <= _Char___init__impl__6a9atx(57) : false;
        } else {
          tmp_2 = false;
        }
        if (!tmp_2) {
          break $l$loop_5;
        }
        i_2 = i_2 + 1 | 0;
      }
      index_1 = i_2;
      var fractionEndIndex = index_1;
      if (fractionEndIndex === index || fractionEndIndex === length) {
        // Inline function 'kotlin.time.handleError' call
        if (throwException)
          throw IllegalArgumentException().o2('');
        return Companion_getInstance().oi_1;
      }
      index = fractionEndIndex;
      var tmp0_4 = fromInt(highPrecisionDigits);
      // Inline function 'kotlin.Long.times' call
      var other = 1000000000;
      // Inline function 'kotlin.Long.plus' call
      var this_6 = multiply(tmp0_4, fromInt(other));
      fractionValue = add(this_6, fromInt(lowPrecisionDigits));
    } else {
      fractionStartIndex = -1;
      fractionValue = 0n;
    }
    var tmp0_elvis_lhs = defaultDurationUnitByShortNameOrNull(value, index);
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.time.handleError' call
      var message_0 = 'Unknown duration unit short name: ' + toString_0(charCodeAt(value, index));
      if (throwException)
        throw IllegalArgumentException().o2(message_0);
      return Companion_getInstance().oi_1;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var unit = tmp_3;
    if (!(prevUnit == null) && prevUnit.e5(unit) <= 0) {
      // Inline function 'kotlin.time.handleError' call
      var message_1 = 'Unexpected order of duration components';
      if (throwException)
        throw IllegalArgumentException().o2(message_1);
      return Companion_getInstance().oi_1;
    }
    prevUnit = unit;
    switch (unit.w1_1) {
      case 1:
        totalMillis = add(totalMillis, divide(longValue, 1000n));
        var tmp_4 = totalMillis;
        // Inline function 'kotlin.Long.div' call

        var this_7 = 4611686018426999999n;
        if (tmp_4 <= divide(this_7, fromInt(1000000))) {
          totalNanos = multiply(modulo(longValue, 1000n), 1000n);
        }

        break;
      case 0:
        var tmp_5 = totalMillis;
        // Inline function 'kotlin.Long.div' call

        var tmp$ret$38 = divide(longValue, fromInt(1000000));
        totalMillis = add(tmp_5, tmp$ret$38);
        var tmp_6 = totalNanos;
        // Inline function 'kotlin.Long.rem' call

        var tmp$ret$39 = modulo(longValue, fromInt(1000000));
        totalNanos = add(tmp_6, tmp$ret$39);
        break;
      default:
        totalMillis = addMillisWithoutOverflow(totalMillis, convertDurationUnitToMilliseconds(longValue, unit));
        break;
    }
    index = index + get_shortNameLength(unit) | 0;
    if (hasFractionalPart) {
      if (index < length) {
        // Inline function 'kotlin.time.handleError' call
        var message_2 = 'Fractional component must be last';
        if (throwException)
          throw IllegalArgumentException().o2(message_2);
        return Companion_getInstance().oi_1;
      }
      totalNanos = add(totalNanos, unit.e5(DurationUnit_MINUTES_getInstance()) >= 0 && (index - fractionStartIndex | 0) > 15 ? parseFractionFallback(value, fractionStartIndex, index - get_shortNameLength(unit) | 0, unit) : fractionDigitsToNanos(fractionValue, unit));
    }
  }
  return Duration__plus_impl_yu9v8f(toDuration_0(totalMillis, DurationUnit_MILLISECONDS_getInstance()), toDuration_0(totalNanos, DurationUnit_NANOSECONDS_getInstance()));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.hs_1 = new (LongParser())(4611686018427387903n, true);
        this.is_1 = new (LongParser())(9223372036854775807n, false);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
function access$_get_overflowLimit__t4uhig($this) {
  return $this.js_1;
}
function access$_get_allowSign__e988q3($this) {
  return $this.ks_1;
}
function access$_get_overflowThreshold__7yqffs($this) {
  return $this.ls_1;
}
function access$_get_lastDigitMax__85wg2($this) {
  return $this.ms_1;
}
var LongParserClass;
function LongParser() {
  if (LongParserClass === VOID) {
    class $ {
      constructor(overflowLimit, allowSign) {
        Companion_getInstance_0();
        this.js_1 = overflowLimit;
        this.ks_1 = allowSign;
        var tmp = this;
        // Inline function 'kotlin.Long.div' call
        var this_0 = this.js_1;
        tmp.ls_1 = divide(this_0, fromInt(10));
        var tmp_0 = this;
        // Inline function 'kotlin.Long.rem' call
        var this_1 = this.js_1;
        tmp_0.ms_1 = modulo(this_1, fromInt(10));
      }
    }
    initMetadataForClass($, 'LongParser');
    LongParserClass = $;
  }
  return LongParserClass;
}
var FractionalParserClass;
function FractionalParser() {
  if (FractionalParserClass === VOID) {
    class $ {}
    initMetadataForObject($, 'FractionalParser');
    FractionalParserClass = $;
  }
  return FractionalParserClass;
}
var FractionalParser_instance;
function FractionalParser_getInstance() {
  return FractionalParser_instance;
}
function fractionDigitsToNanos(_this__u8e3s4, unit) {
  // Inline function 'kotlin.Long.times' call
  var other = get_fractionMultiplier(unit);
  var tmp$ret$0 = toNumber(_this__u8e3s4) * other;
  return roundToLong(tmp$ret$0);
}
function isoDurationUnitByShortNameOrNull(_this__u8e3s4, start) {
  var tmp0_subject = charCodeAt(_this__u8e3s4, start);
  return tmp0_subject === _Char___init__impl__6a9atx(68) ? DurationUnit_DAYS_getInstance() : tmp0_subject === _Char___init__impl__6a9atx(72) ? DurationUnit_HOURS_getInstance() : tmp0_subject === _Char___init__impl__6a9atx(77) ? DurationUnit_MINUTES_getInstance() : tmp0_subject === _Char___init__impl__6a9atx(83) ? DurationUnit_SECONDS_getInstance() : null;
}
function defaultDurationUnitByShortNameOrNull(_this__u8e3s4, start) {
  var first = charCodeAt(_this__u8e3s4, start);
  var second = start < get_lastIndex(_this__u8e3s4) ? charCodeAt(_this__u8e3s4, start + 1 | 0) : _Char___init__impl__6a9atx(0);
  return first === _Char___init__impl__6a9atx(100) ? DurationUnit_DAYS_getInstance() : first === _Char___init__impl__6a9atx(104) ? DurationUnit_HOURS_getInstance() : first === _Char___init__impl__6a9atx(115) ? DurationUnit_SECONDS_getInstance() : first === _Char___init__impl__6a9atx(109) ? second === _Char___init__impl__6a9atx(115) ? DurationUnit_MILLISECONDS_getInstance() : DurationUnit_MINUTES_getInstance() : first === _Char___init__impl__6a9atx(117) ? second === _Char___init__impl__6a9atx(115) ? DurationUnit_MICROSECONDS_getInstance() : null : first === _Char___init__impl__6a9atx(110) ? second === _Char___init__impl__6a9atx(115) ? DurationUnit_NANOSECONDS_getInstance() : null : null;
}
function get_shortNameLength(_this__u8e3s4) {
  switch (_this__u8e3s4.w1_1) {
    case 2:
    case 1:
    case 0:
      return 2;
    default:
      return 1;
  }
}
function parseFractionFallback(_this__u8e3s4, startIndex, endIndex, unit) {
  return roundToLong(toDouble(substring(_this__u8e3s4, startIndex, endIndex)) * toNumber(get_fallbackFractionMultiplier(unit)));
}
function get_fractionMultiplier(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 0:
      tmp = 1.0E-15;
      break;
    case 1:
      tmp = 1.0E-12;
      break;
    case 2:
      tmp = 1.0E-9;
      break;
    case 3:
      tmp = 1.0E-6;
      break;
    case 4:
      tmp = 6.0E-5;
      break;
    case 5:
      tmp = 0.0036;
      break;
    case 6:
      tmp = 0.0864;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Unknown unit: ' + _this__u8e3s4.toString();
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
function get_fallbackFractionMultiplier(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.w1_1) {
    case 4:
      tmp = 60000000000n;
      break;
    case 5:
      tmp = 3600000000000n;
      break;
    case 6:
      tmp = 86400000000000n;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'Invalid unit: ' + _this__u8e3s4.toString() + ' for fallback fraction multiplier';
      throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
//region block: init
FractionalParser_instance = new (FractionalParser())();
//endregion
//region block: exports
export {
  Duration__compareTo_impl_pchp0f as Duration__compareTo_impl_pchp0f1efu9z6fxx84c,
  Duration__hashCode_impl_u4exz6 as Duration__hashCode_impl_u4exz62capomnnb6e8m,
  _Duration___get_inWholeDays__impl__7bvpxz as _Duration___get_inWholeDays__impl__7bvpxz18sb9z2fv6ft,
  _Duration___get_inWholeMicroseconds__impl__8oe8vv as _Duration___get_inWholeMicroseconds__impl__8oe8vv3ftjral8oy9p8,
  _Duration___get_inWholeMilliseconds__impl__msfiry as _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p,
  _Duration___get_inWholeSeconds__impl__hpy7b3 as _Duration___get_inWholeSeconds__impl__hpy7b32eiwxtrg2km04,
  Duration__isPositive_impl_tvkkt2 as Duration__isPositive_impl_tvkkt21kbfx1jd6pv59,
  _Duration___get_nanosecondsComponent__impl__nh19kq as _Duration___get_nanosecondsComponent__impl__nh19kq3iktsl2r73tda,
  Duration__plus_impl_yu9v8f as Duration__plus_impl_yu9v8fuwslfu377uhg,
  Duration__toDouble_impl_a56y2b as Duration__toDouble_impl_a56y2b33i3iqk8qiaoq,
  Duration__toInt_impl_nnev71 as Duration__toInt_impl_nnev71nqnqg0mybell,
  Duration__toIsoString_impl_9h6wsm as Duration__toIsoString_impl_9h6wsm1isvj2n1k1yz8,
  Duration__toString_impl_8d916b as Duration__toString_impl_8d916b1pmuuqkmfodll,
  Duration__unaryMinus_impl_x2k1y0 as Duration__unaryMinus_impl_x2k1y036zdiljvbimse,
  Companion_getInstance as Companion_getInstance2jahap30xtp3t,
  Duration as Duration5ynfiptaqcrg,
  toDuration_1 as toDuration28gf6ughsr3vf,
  toDuration_0 as toDurationba1nlt78o6vu,
  toDuration as toDuration7gy6v749ektt,
};
//endregion

//# sourceMappingURL=Duration.mjs.map
